import { NgModule } from '@angular/core';
import { ChartistComponent } from './chartist.component';

@NgModule({
  declarations: [ChartistComponent],
  imports: [],
  exports: [ChartistComponent]
})
export class ChartistModule {}
